<template>
	<Layout class="p-5 bg-white">
		<Form class="p-5" :model="user" :label-width="80">
			<Row>
				<Col span="12" align="center">
				<FormItem class="w-200" label="用户编号">
					<h4>{{user.userId}}</h4>
				</FormItem>
				<FormItem class="w-200" label="用户名">
					<Input v-model="user.userName" />
				</FormItem>
				<FormItem class="w-200" label="账号">
					<Input v-model="user.account" />
				</FormItem>
				<FormItem class="w-200" label="密码">
					<Input v-model="user.password" />
				</FormItem>
				<FormItem class="w-200" label="电话">
					<Input v-model="user.tel" />
				</FormItem>
				<FormItem class="w-200">
					<Button @click="submit" type="primary" size="large">提交</Button>
					<Button @click="cancel" style="margin-left: 8px" size="large">取消</Button>
				</FormItem>
				<FormItem class="w-200">
					<Button @click="deviceList(user.userId)" type="primary" size="large">查看设备</Button>
				</FormItem>

				</Col>
			</Row>


			<FormItem>
			</FormItem>
		</Form>
	</Layout>

</template>
<script>
	export default {
		data() {
			return {
				user: {
					userId: "",
					account: "",
					password: "",
					tel: "",
					userName: "",
					adm: "",
					lie: "",

					nickName: "",
					password: "",
				},
				userId: 0,
				roles: [],
				allRoles: [],
				// updateFlg: false,
				// oldUser: {},
				// oldRoles: [],

			}
		},
		methods: {
			cancel: function() {
				this.$tabs.close();
			},
			submit: function() {
				var self = this;
				this.http.put({
					url: "/user/update",
					param: self.user,
				}).then(() => {
					self.message.info("修改成功");
				});
			},
			init: function() {
				this.searchUser();
			},
			searchUser: function() {
				let self = this;
				this.http.get({
					url: "/user/page",
					param: self.user
				}).then(data => {
					self.user = data.DATA.records[0];
				});
			},
			deviceList(userId) {
				
				this.$router.push({
					name: "device",
					params: {userId}
				})
			},

		},
		created: function() {},
		mounted: function() {
			this.$data.user.userId = this.$route.params.userId;
			this.init();
		}
	}
</script>

<style>
</style>
